// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './modules/login/components/login/login.component';
//import { HabilitarComponent } from './components/habilitar/habilitar.component';


const routes: Routes = [    
    {
        path: '',
        component: LoginComponent
    },  
    {
        path: 'recuperar-cuenta',
        redirectTo: '/recuperar-cuenta/autenticacion',
        pathMatch: 'full'
    },
    {
        path: 'habilitar-cuenta',
        redirectTo: '/habilitar-cuenta/autenticacion',
        pathMatch: 'full'
    }
    /*{
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },*/
    /*{
        path: 'recuperar-cuenta',
        redirectTo: '/recuperar-cuenta',
        pathMatch: 'full'
    },
    {
        path: 'habilitar-cuenta',
        redirectTo: '/habilitar-cuenta',
        pathMatch: 'full'
    },
    {
        path: 'habilitar-cuenta/autenticacion',
        redirectTo: '/habilitar-cuenta/autenticacion',
        pathMatch: 'full'
    } */   

    /*{
        path: '',
        redirectTo: '/recuperar-cuenta/autenticacion',
        pathMatch: 'full'
    },
    {
        path: 'autenticacion',
        redirectTo: '/recuperar-cuenta/autenticacion',
        pathMatch: 'full'
    }*/
    /*{ path: '', component: LoginComponent }, 
    { path: 'login', component: LoginComponent },
    { path: 'habilitar', component: HabilitarComponent }*/
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/app-routing.module.ts